// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1e_O4","messages":"Chat_messages__3YwOG","dateDivider":"Chat_dateDivider__1efDF"};